import { useMemo } from 'react';
import { ExpressionType } from '../../../../expressions/IExpression';
import { ComputeExpression } from '../../../../expressions/compute/ComputeExpression';
import { useMaterializedExpressionReferences } from '../../../../expressions/render/hooks/useMaterializedExpressionReferences';
import { useWatchReferences } from '../../../../expressions/render/hooks/useWatchReferences';
import { IFunctionExpression } from '../../../../expressions/repository/function/IFunctionExpression';
import { hydrateComputedString } from './hydrateComputedString';

/**
 * Risolve l'espressione del campo calcolato stringa.
 */
export function useStringExpressionValue(
  name: string,
  widgetExpression: ComputeExpression,
) {
  const expression: IFunctionExpression = useMemo(
    () => ({
      type: ExpressionType.Function,
      value: widgetExpression,
    }),
    [widgetExpression],
  );

  const { references } = useMaterializedExpressionReferences(name, expression);

  const variables = useWatchReferences(references);

  const result = useMemo(() => {
    return hydrateComputedString(expression.value.value, variables);
  }, [expression.value.value, variables]);

  return result;
}
